var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',{staticClass:"app"},[_c('Sidebar'),_c('b-container',{staticClass:"wrapper",attrs:{"fluid":""}},[_c('Menu'),_c('router-view')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }